module.exports = __webpack_public_path__ + "assets/a64b6fb1aafb85db868b40ed7f276249.png";